import { supabase } from "../Db_Connections/db_connection"; 

/* =========================
   READ – Get All Leaves (Admin ke liye)
========================= */
export async function getLeaves() {
  const { data, error } = await supabase
    .from("leaves")
    .select(`
      *,
      profiles:profile_id (first_name, last_name, email, designation)
    `)
    .order("created_at", { ascending: false });

  return { data, error };
}

export async function getLeaveById(id) {
  const { data, error } = await supabase
    .from("leaves")
    .select("*")
    .eq("id", id)
    .single();

  return { data, error };
}

/* =========================
   READ – Get Leaves By Profile (User ke liye)
========================= */
export async function getLeavesByProfile(profile_id) {
  const { data, error } = await supabase
    .from("leaves")
    .select("*")
    .eq("profile_id", profile_id)
    .order("start_date", { ascending: false });

  return { data, error };
}

  //  HELPER – Monthly Leave Count

export async function getMonthlyLeaveCount(profile_id, start_date) {
  const selectedDate = new Date(start_date);

  const year = selectedDate.getFullYear();
  const month = selectedDate.getMonth();

  const monthStart = new Date(year, month, 1).toISOString().split("T")[0];
  const monthEnd = new Date(year, month + 1, 0).toISOString().split("T")[0];

  const { data, error } = await supabase
    .from("leaves")
    .select("id, leave_type, status")
    .eq("profile_id", profile_id)
    .gte("start_date", monthStart)
    .lte("start_date", monthEnd)
    .in("status", ["Pending", "Approved"])
    .in("leave_type", ["Casual Leave", "Sick Leave"]);

  return { data, error };
}

// export async function addLeave(data) {
//   const { data: result, error } = await supabase
//     .from("leaves")
//     .insert([
//       {
//         profile_id: data.profile_id,  // Login user ki ID
//         leave_type: data.leave_type,  // Sick, Casual, etc.
//         start_date: data.start_date,
//         end_date: data.end_date,
//         total_days: data.total_days,
//         reason: data.reason,
//         status: "Pending",            // Default Pending rahega
//         approved_by: null             // Abhi kisi ne approve nahi kiya
//       },
//     ])
//     .select()
//     .single();

//   return { data: result, error };
// }

export async function addLeave(data) {
  //  Monthly limit check
  if (data.leave_type === "Casual Leave" || data.leave_type === "Sick Leave") {
    const { data: monthlyLeaves, error: countError } =
      await getMonthlyLeaveCount(data.profile_id, data.start_date);

    if (countError) {
      return { error: { message: "Error checking leave limit" } };
    }

    if (monthlyLeaves.length >= 2) {
      return {
        error: {
          message: "You can only apply for 2 leaves in a month."
        }
      };
    }
  }

  // Insert
  const { data: result, error } = await supabase
    .from("leaves")
    .insert([
      {
        profile_id: data.profile_id,
        leave_type: data.leave_type,
        start_date: data.start_date,
        end_date: data.end_date,
        total_days: data.total_days,
        reason: data.reason,
        status: "Pending",
        approved_by: null
      },
    ])
    .select()
    .single();

  return { data: result, error };
}
/* =========================
   UPDATE – Update Leave (Edit or Approve/Reject)
========================= */
export async function updateLeave(id, data) {
  // Hum wahi fields update karenge jo 'data' me aayengi
  const updateFields = {};

  if (data.leave_type) updateFields.leave_type = data.leave_type;
  if (data.start_date) updateFields.start_date = data.start_date;
  if (data.end_date) updateFields.end_date = data.end_date;
  if (data.total_days) updateFields.total_days = data.total_days;
  if (data.reason) updateFields.reason = data.reason;
  if (data.status) updateFields.status = data.status; // Approved/Rejected
  if (data.approved_by) updateFields.approved_by = data.approved_by; // Admin ID

  const { data: result, error } = await supabase
    .from("leaves")
    .update(updateFields)
    .eq("id", id)
    .select();
   

  return { data: result, error };
}

/* =========================
   DELETE – Delete Leave
========================= */
export async function deleteLeave(id) {
  const { error } = await supabase
    .from("leaves")
    .delete()
    .eq("id", id);

  return { error };
}